export interface PublicEvent {
  title: string;
  slug: string;
  event_date: string;
  date_time_label: string | null;
  time_range: string | null;
  location_name: string | null;
  location_line_1: string | null;
  location_line_2: string | null;
  format: string | null;
  category: string | null;
  description: string | null;
  presenter_name: string | null;
  partner_names: string[];
  registration_url: string | null;
  image_url: string | null;
  flyer_en_url: string | null;
  flyer_es_url: string | null;
  topics: string[];
  event_notes: string[];
  contact_phone: string | null;
  announcement_text: string | null;
  flyer_en_alt: string | null;
  flyer_es_alt: string | null;
  start_date_time: string;
  end_date_time: string;
  seo_title: string;
  seo_description: string;
  canonical_path: string;
}

export const HELOC_EVENT_SLUG = "home-equity-line-of-credit-workshop";

// Static published event config used by listing, detail, TopBar, and prerender SEO.
export const HELOC_EVENT: PublicEvent = {
  title: "Home Equity Line of Credit (HELOC) Workshop",
  slug: HELOC_EVENT_SLUG,
  event_date: "2026-10-13",
  date_time_label: "Tuesday, October 13, 2026",
  time_range: "5:30 PM – 7:00 PM",
  location_name: "LHAND Community Room",
  location_line_1: "10 Church Street",
  location_line_2: "Lynn, MA 01902",
  format: "Free · In person · 1.5 hours",
  category: "Community Workshop",
  description:
    "Learn how you may be able to put your home's equity to work. Hadassah Homes is partnering with the Lynn Housing Authority & Neighborhood Development and Rockland Trust for a free community workshop covering home equity, financing opportunities, renovations, investment properties, banking, and financial wellness.",
  presenter_name: "Lynn Housing Authority & Neighborhood Development (LHAND)",
  partner_names: ["Rockland Trust", "Hadassah Homes"],
  registration_url: "https://lhand.org/program/home-ownership/",
  image_url: "/events/home-equity-line-of-credit-workshop/heloc-workshop-card.jpg",
  flyer_en_url: "/events/home-equity-line-of-credit-workshop/heloc-workshop-english.jpeg",
  flyer_es_url: "/events/home-equity-line-of-credit-workshop/heloc-workshop-spanish.jpeg",
  topics: [
    "Home Equity",
    "Renovating & Remodeling",
    "Investment, Vacation & Second Properties",
    "Business Start-Up",
    "Banking",
    "Financial Wellness",
    "And more",
  ],
  event_notes: [
    "The class will be held in English.",
    "Light refreshments will be provided.",
  ],
  contact_phone: "781-581-8600",
  announcement_text: "Free HELOC Workshop • October 13 in Lynn",
  flyer_en_alt:
    "English flyer for the Home Equity Line of Credit Workshop on October 13, 2026 in Lynn, Massachusetts.",
  flyer_es_alt:
    "Spanish flyer for the Home Equity Line of Credit Workshop on October 13, 2026 in Lynn, Massachusetts.",
  start_date_time: "2026-10-13T17:30:00-04:00",
  end_date_time: "2026-10-13T19:00:00-04:00",
  seo_title: "Home Equity Line of Credit Workshop | Hadassah Homes",
  seo_description:
    "Join Hadassah Homes, LHAND, and Rockland Trust for a free Home Equity Line of Credit workshop in Lynn, MA on October 13, 2026.",
  canonical_path: "/events/home-equity-line-of-credit-workshop",
};
